/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

const INSTALLATION_NAME_PLACEHOLDER = '[INSTALLATION_NAME]';
const DEFAULT_INSTALLATION_NAME = 'SiteUP CRM';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = (
      globalConfig.value?.installationName || DEFAULT_INSTALLATION_NAME
    ).replace(/\bChatwoot\b/gi, DEFAULT_INSTALLATION_NAME);

    return text
      .replaceAll(INSTALLATION_NAME_PLACEHOLDER, installationName)
      .replace(/Chatwoot/gi, installationName);
  };

  return {
    replaceInstallationName,
  };
}
